import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  isCancelling: false,
  isFinalising: false,
  isGeneratingDraftBooking: false,
  changes: {},
  oweUserMoney: 0, // price change after fees, > 0 means user needs to be refunded, < 0 means user needs to pay
  amendmentFee: 0,
  cancellationFee: 0,
  fees: [],
};

export const draftSummaryOfChangesSlice = createSlice({
  name: 'draftSummaryOfChanges',
  initialState: {
    ...initialState,
  },
  reducers: {
    setShow: (state, action) => {
      state.show = action.payload;
    },
    setIsCancelling: (state, action) => {
      state.isCancelling = action.payload;
    },
    setIsFinalising: (state, action) => {
      state.isFinalising = action.payload;
    },
    setIsGeneratingDraftBooking: (state, action) => {
      state.isGeneratingDraftBooking = action.payload;
    },
    setChanges: (state, action) => {
      state.changes = action.payload;
    },
    setOweUserMoney: (state, action) => {
      const { before: sourceBookingPrice, after: draftBookingPrice } =
        action.payload.price;
      const priceDifference = sourceBookingPrice - draftBookingPrice;
      const oweUserMoney =
        priceDifference - state.amendmentFee - state.cancellationFee;
      state.oweUserMoney = oweUserMoney;
    },
    setFees: (state, action) => {
      state.fees = action.payload;
    },
    setAmendmentFee: (state, action) => {
      const fees = action.payload;
      state.amendmentFee = fees
        .filter((fee) => fee.fee_type === 'Amendment')
        .map((fee) => fee.fee_in_cents)
        .reduce((acc, fee) => acc + fee, 0);
    },
    setCancellationFee: (state, action) => {
      const fees = action.payload;
      state.cancellationFee = fees
        .filter((fee) => fee.fee_type === 'Cancellation')
        .map((fee) => fee.fee_in_cents)
        .reduce((acc, fee) => acc + fee, 0);
    },
    resetStore: () => initialState,
  },
});

export const getFeeIds = (state) =>
  state.draftSummaryOfChanges.fees.map((fee) => fee.id);

export const {
  setShow,
  setIsCancelling,
  setIsFinalising,
  setIsGeneratingDraftBooking,
  setChanges,
  setOweUserMoney,
  setFees,
  setAmendmentFee,
  setCancellationFee,
  resetStore,
} = draftSummaryOfChangesSlice.actions;
export default draftSummaryOfChangesSlice.reducer;
